export default "__VITE_ASSET__M2cmfrPp__"